const authToken = process.env.REACT_APP_TOKEN_key;
const apiKey = process.env.REACT_APP_API_key;

export const api = process.env.REACT_APP_API_NAME;
export const envType = process.env.REACT_APP_TYPE;

export const headers = {
  "Content-Type": "application/json",
  "x-api-key": apiKey,
  Authorization: `Bearer ${authToken}`,
};
